export default __webpack_public_path__ + "static/media/logo.d2ce5ef7.svg";